import { styled, Box } from "@mui/material";

export const FolderWindowWrapper = styled(Box)({
    height: "calc(100% - 60px)",
    boxSizing: "border-box",
    display: "flex",
    paddingTop: "20px",
});